import { useEffect, useState } from 'react';
import { MessageItemProps } from '@/components/ConversationWithTutor/MessageItem/MessageItem';
import {
  TutorChatMessage,
  TutorChatSender,
  TutorChat,
  getTutorChatsData,
} from '@mavatar/melingo-voice-and-avatar-sdk';
import Chat from '@/components/ConversationWithTutor/Chat/Chat';

interface HistoryProps {
  chatId: string;
  onClose: () => void;
}

const History = ({ chatId, onClose }: HistoryProps) => {
  const [welcomeMessage, setWelcomeMessage] = useState<TutorChatMessage | undefined>({
    status: 'writing',
    sender: TutorChatSender.TUTOR,
  });
  const [startMessages, setStartMessages] = useState<MessageItemProps[] | undefined>();

  useEffect(() => {
    const abortController = new AbortController();
    const abortSignal = abortController.signal;

    const showHistory = async () => {
      const chatData = await getTutorChatsData({
        filters: {
          ChatId: chatId,
        },
      });

      if (abortSignal.aborted || !chatData?.length) {
        return;
      }

      const tutorChat = new TutorChat({});
      (chatData[0].ChatMessages || []).forEach(m => {
        const message = tutorChat.messageMap(m);
        message.disableAutoSpeaker = true;
        tutorChat.insertMessage(message);
      });

      setWelcomeMessage(undefined);
      setStartMessages(
        tutorChat.messages.map(m => {
          return {
            message: m,
            showSpeaker: false,
            voice: '',
          };
        })
      );
    };

    showHistory();

    return () => {
      abortController.abort();
    };
  }, [chatId]);

  return (
    <Chat
      welcomeMessage={welcomeMessage}
      startMessages={startMessages}
      onClose={onClose}
      speechType='TEXT'
      layout='history'
    />
  );
};

export default History;
